import { Grid, Button, TextField, Select, MenuItem, Checkbox, Autocomplete } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useContext } from "react";
import { Stack } from "@mui/material";
import { ApiContext } from "../../../App";
import { timeZonesNames } from '@vvo/tzdb';

const DEFAULT_CLIENT_DATA = { timezone: "Europe/London", currency_symbol: "£", hidden_pages: [], home_page_path: "" };

const PAGE_PATHS_TO_NAMES = { "": "Default", "status": "Status", "automation": "Automation", "alerts": "Alerts", "tasks": "Tasks", "metering": "Metering", "trends": "Trends", "reports": "Reports", "savings": "Savings", "occupancy": "Occupancy" };

const ClientForm = ({ client }) => {
    const { t } = useTranslation();
    const [errorMessages, setErrorMessages] = useState({});
    const [clientData, setClientData] = useState(DEFAULT_CLIENT_DATA);


    const { clientApi } = useContext(ApiContext)

    useEffect(() => {
        clientApi.getClient(
            data => {
                let validatedHiddenPages = [];
                if (data.hidden_pages) {
                    if (Array.isArray(data.hidden_pages)) {
                        validatedHiddenPages = data.hidden_pages.filter(page => Object.keys(PAGE_PATHS_TO_NAMES).includes(page));
                    }
                };
                if (data.home_page_path && !Object.keys(PAGE_PATHS_TO_NAMES).includes(data.home_page_path)) {
                    data.home_page_path = "";
                }
                setClientData({
                    timezone: data.timezone,
                    currency_symbol: data.currency_symbol,
                    hidden_pages: validatedHiddenPages,
                    home_page_path: data.home_page_path ?? ''
                });
            },
            () => {
                alert(t("Couldn't connect to server."));
            }
        )
    }, [client])


    const handleUpdate = () => {
        clientApi.updateClient(
            clientData,
            () => {
                setErrorMessages({});
                alert(t("Updated correctly."))
            }, (errors) => {
                setErrorMessages(errors);
                alert(t("Couldn't update settings."))
            }
        )
    }

    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Autocomplete
                options={timeZonesNames}
                getOptionLabel={(option) => option}
                renderInput={(params) =>
                    <TextField {...params}
                        label={t("Timezone")}
                        error={errorMessages.hasOwnProperty("timezone")}
                        helperText={errorMessages["timezone"] ? errorMessages["timezone"] : ""}
                        variant="standard"
                    />
                }
                value={clientData.timezone}
                onChange={(event, newValue) => setClientData({ ...clientData, timezone: newValue })}
                sx={{ minWidth: 200 }}
            />
            <TextField
                label={t("Currency")}
                variant="standard"
                id={"currency_symbol"}
                type="text"
                value={clientData.currency_symbol}
                onChange={(event) => setClientData({ ...clientData, currency_symbol: event.target.value })}
                error={errorMessages.hasOwnProperty("currency_symbol")}
                helperText={errorMessages["currency_symbol"] ? errorMessages["currency_symbol"] : ""}
            />
            <TextField
                select
                label={t("Hidden Pages")}
                variant="standard"
                id={"hidden_pages"}
                value={clientData.hidden_pages}
                onChange={(event) => setClientData({ ...clientData, hidden_pages: event.target.value })}
                SelectProps={{
                    multiple: true,
                    renderValue: (selected) => selected.map((path) => t(PAGE_PATHS_TO_NAMES[path])).join(', '),
                }}
                sx={{ minWidth: 200 }}
            >
                {Object.keys(PAGE_PATHS_TO_NAMES).map((path) => (
                    <MenuItem key={path} value={path}>
                        <Checkbox checked={clientData.hidden_pages.includes(path)} />
                        {t(PAGE_PATHS_TO_NAMES[path])}
                    </MenuItem>
                ))}
            </TextField>
            <Autocomplete
                options={Object.keys(PAGE_PATHS_TO_NAMES)}
                getOptionLabel={(option) => t(PAGE_PATHS_TO_NAMES[option])}
                renderInput={(params) =>
                    <TextField {...params} label={t("Default Home Page")}
                        error={errorMessages.hasOwnProperty("home_page_path")}
                        helperText={errorMessages["home_page_path"] ? errorMessages["home_page_path"] : ""}
                        variant="standard"
                    />
                }
                value={clientData.home_page_path ?? ''}
                onChange={(event, newValue) => setClientData({ ...clientData, home_page_path: newValue ?? '' })}
                disablePortal
                sx={{ minWidth: 200 }}
            />

            <Button variant='contained' onClick={handleUpdate}>
                {t("Update")}
            </Button>
        </Stack>
    );
}

export default ClientForm;

